import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import AccountDetailsPage, { getDefaultPageUI } from "components/pages/AccountDetailsPage";

export default function CaptureAccountsDateDD(props) {
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "searchAccordion", "isActive" ], true)
        .update([ "searchDateRange" , "isActive" ], true)
        .submit();

    return <AccountDetailsPage ui={ ui } />
}